import type { EditorJSONState } from '@core/prosemirror-types';
import type { SymbolEmoji } from '@core/symbol-legacy';
import { TellentOrgAbilities, TellentOrgAbilitiesExtended } from '@core/tellent-types';

export type AskTicketPriority = 'low' | 'normal' | 'high' | 'urgent';
export type AskTicketStatus = 'open' | 'in_progress' | 'closed';

export enum AskHrChatFeatureId {
  Tickets = 'ask-hr-tickets',
  Forms = 'ask-hr-forms',
  Form = 'ask-hr-form',
}

export interface TellentMemberBrief {
  guid: string;
  abilities: Array<TellentOrgAbilities | TellentOrgAbilitiesExtended>;
  avatarThumbUrl: string | null;
  email: string;
  firstName: string;
  lastName: string;
  owner: boolean;
  status: 'active' | 'deactivated' | string;
  userGuid: string;
}

export interface AskTemplateViewItem {
  id: number;
  autoAssignees: TellentMemberBrief[];
  descriptionJson: EditorJSONState;
  form: unknown;
  name: string;
  symbol: SymbolEmoji | null;
  updatedAt: string;
  createdAt: string;
  active: boolean;
}

export interface AskTicketBoardItem {
  id: number;
  assignees: TellentMemberBrief[];
  name: string;
  priority: AskTicketPriority | null;
  requester: TellentMemberBrief;
  status: AskTicketStatus;
  symbol: SymbolEmoji | null;
  updatedAt: string;
  createdAt: string;
}
